import React from 'react';

export const UnverifiedIcon = ({ className = '' }) => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      className={className}
      data-palette="UnverifiedIcon">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g>
                <path
                  d="M0 0L14 0 14 14 0 14z"
                  transform="translate(-1162 -65) translate(952 26) translate(205 34) translate(5 5)"
                />
                <path
                  fill="#202C38"
                  fillRule="nonzero"
                  d="M1.167 2.33c.002-.32.26-.577.578-.58h10.51c.32 0 .578.26.578.58v9.34c-.002.32-.26.577-.578.58H1.745c-.32 0-.578-.26-.578-.58V2.33zm1.166.587v8.166h9.334V2.917H2.333zM3.5 4.083H7v3.5H3.5v-3.5zM4.667 5.25v1.167h1.166V5.25H4.667zM3.5 8.75h7v1.167h-7V8.75zm4.667-4.667H10.5V5.25H8.167V4.083zm0 2.334H10.5v1.166H8.167V6.417z"
                  transform="translate(-1162 -65) translate(952 26) translate(205 34) translate(5 5)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export const TwoFAuthIcon = ({ className }) => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      className={className}
      data-palette="TwoFAuthIcon">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g transform="translate(-965 -130) translate(952 26) translate(13 104)">
              <rect width="26" height="25.971" fillRule="nonzero" rx="8" />
              <g>
                <path d="M0 0L24 0 24 24 0 24z" transform="translate(1 2)" />
                <path
                  fill="#F66"
                  fillRule="nonzero"
                  d="M7 10h13c.552 0 1 .448 1 1v10c0 .552-.448 1-1 1H4c-.552 0-1-.448-1-1V11c0-.552.448-1 1-1h1V9c-.001-3.247 2.231-6.07 5.392-6.815 3.16-.746 6.419.779 7.87 3.684l-1.789.894c-1.037-2.075-3.364-3.165-5.622-2.632C8.593 4.664 6.999 6.681 7 9v1zm-2 2v8h14v-8H5zm5 3h4v2h-4v-2z"
                  transform="translate(1 2)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export const ReferAndEarnIcon = ({ className }) => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      className={className}
      data-palette="ReferAndEarnIcon">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g transform="translate(-965 -174) translate(952 26) translate(13 148)">
              <rect width="26" height="26" fillRule="nonzero" rx="8" />
              <g>
                <path d="M0 0L22 0 22 22 0 22z" transform="translate(2 2)" />
                <path
                  fill="var(--dropdownIconColor)"
                  fillRule="nonzero"
                  d="M12.027 15.604l-3.85-2.099c-1.028 1.1-2.624 1.459-4.024.906s-2.32-1.905-2.32-3.41c0-1.506.92-2.858 2.32-3.411 1.4-.553 2.996-.194 4.025.906l3.85-2.1c-.453-1.79.497-3.637 2.216-4.311 1.719-.674 3.67.035 4.556 1.655.886 1.62.428 3.646-1.068 4.729-1.496 1.082-3.563.884-4.825-.464l-3.85 2.1c.147.587.147 1.203 0 1.79l3.849 2.1c1.262-1.348 3.33-1.546 4.825-.464 1.496 1.083 1.954 3.108 1.068 4.729-.885 1.62-2.837 2.33-4.556 1.655-1.72-.674-2.669-2.521-2.216-4.311zM5.5 12.834c1.013 0 1.833-.821 1.833-1.834 0-1.013-.82-1.833-1.833-1.833S3.667 9.987 3.667 11s.82 1.833 1.833 1.833zm10.083-5.5c1.013 0 1.834-.821 1.834-1.834 0-1.013-.821-1.833-1.834-1.833-1.012 0-1.833.82-1.833 1.833s.82 1.833 1.833 1.833zm0 11c1.013 0 1.834-.821 1.834-1.834 0-1.013-.821-1.833-1.834-1.833-1.012 0-1.833.82-1.833 1.833s.82 1.833 1.833 1.833z"
                  transform="translate(2 2)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export const SecurityIcon = ({ className }) => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      className={className}
      data-palette="SecurityIcon">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g>
                <path
                  d="M0 0L22 0 22 22 0 22z"
                  transform="translate(-966 -220) translate(952 26) translate(12 192) translate(2 2)"
                />
                <path
                  fill="var(--dropdownIconColor)"
                  fillRule="nonzero"
                  d="M1.1525 2.35501L8 0.833344L14.8475 2.35501C15.0326 2.39615 15.198 2.49915 15.3167 2.64701C15.4353 2.79488 15.5 2.97877 15.5 3.16834V11.4908C15.4999 12.314 15.2967 13.1243 14.9082 13.85C14.5198 14.5757 13.9582 15.1943 13.2733 15.6508L8 19.1667L2.72667 15.6508C2.04189 15.1944 1.48038 14.5759 1.09196 13.8504C0.70353 13.1248 0.500197 12.3146 0.5 11.4917V3.16834C0.500033 2.97877 0.564698 2.79488 0.683325 2.64701C0.801951 2.49915 0.967447 2.39615 1.1525 2.35501ZM2.16667 3.83668V11.4908C2.16668 12.0396 2.30215 12.5798 2.56105 13.0636C2.81996 13.5474 3.19429 13.9598 3.65083 14.2642L8 17.1642L12.3492 14.2642C12.8056 13.9599 13.1799 13.5476 13.4388 13.0639C13.6977 12.5803 13.8332 12.0403 13.8333 11.4917V3.83668L8 2.54168L2.16667 3.83668ZM7.16667 8.33334V5.83334H8.83333V8.33334H11.3333V10H8.83333V12.5H7.16667V10H4.66667V8.33334H7.16667Z"
                  transform="translate(-966 -220) translate(952 26) translate(12 192) translate(2 2)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export const ApiKeysIcon = ({ className }) => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      className={className}
      style={{ marginTop: '10px' }}
      data-palette="ApiKeysIcon">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g>
                <path
                  d="M0 0L22 0 22 22 0 22z"
                  transform="translate(-967 -264) translate(952 26) translate(13 236) translate(2 2)"
                />
                <path
                  fill="var(--dropdownIconColor)"
                  fillRule="nonzero"
                  d="M1.50008 0.5H16.5001C16.7211 0.5 16.9331 0.587797 17.0893 0.744078C17.2456 0.900358 17.3334 1.11232 17.3334 1.33333V14.6667C17.3334 14.8877 17.2456 15.0996 17.0893 15.2559C16.9331 15.4122 16.7211 15.5 16.5001 15.5H1.50008C1.27907 15.5 1.06711 15.4122 0.910826 15.2559C0.754545 15.0996 0.666748 14.8877 0.666748 14.6667V1.33333C0.666748 1.11232 0.754545 0.900358 0.910826 0.744078C1.06711 0.587797 1.27907 0.5 1.50008 0.5ZM2.33341 2.16667V13.8333H15.6667V2.16667H2.33341ZM9.00008 10.5H14.0001V12.1667H9.00008V10.5ZM6.22258 8L3.86508 5.64333L5.04425 4.46417L8.57925 8L5.04425 11.5358L3.86508 10.3567L6.22258 8Z"
                  transform="translate(-967 -264) translate(952 26) translate(13 236) translate(2 2)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export const TrnLogsIcon = ({ className }) => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      className={className}
      data-palette="TrnLogsIcon">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g>
                <path
                  d="M0 0L22 0 22 22 0 22z"
                  transform="translate(-966 -308) translate(952 26) translate(12 280) translate(2 2)"
                />
                <path
                  fill="var(--dropdownIconColor)"
                  fillRule="nonzero"
                  d="M17.417 20.167H4.583c-1.518 0-2.75-1.232-2.75-2.75V2.75c0-.506.41-.917.917-.917h12.833c.507 0 .917.41.917.917v11h3.667v3.667c0 1.518-1.232 2.75-2.75 2.75zm-.917-4.584v1.834c0 .506.41.916.917.916.506 0 .916-.41.916-.916v-1.834H16.5zm-1.833 2.75V3.667h-11v13.75c0 .506.41.916.916.916h10.084zM5.5 6.417h7.333V8.25H5.5V6.417zm0 3.666h7.333v1.834H5.5v-1.834zm0 3.667h4.583v1.833H5.5V13.75z"
                  transform="translate(-966 -308) translate(952 26) translate(12 280) translate(2 2)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export const FeedBackIcon = ({ className }) => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className={className}
      data-palette="FeedBackIcon">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g>
                <path
                  d="M0 0L24 0 24 24 0 24z"
                  transform="translate(-965 -351) translate(952 26) translate(12 324) translate(1 1)"
                />
                <path
                  fill="var(--dropdownIconColor)"
                  fillRule="nonzero"
                  d="M6.455 19L2 22.5V4c0-.552.448-1 1-1h18c.552 0 1 .448 1 1v14c0 .552-.448 1-1 1H6.455zm-.692-2H20V5H4v13.385L5.763 17zM11 10h2v2h-2v-2zm-4 0h2v2H7v-2zm8 0h2v2h-2v-2z"
                  transform="translate(-965 -351) translate(952 26) translate(12 324) translate(1 1)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export const LogoutIcon = ({ className }) => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      className={className}
      data-palette="LogoutIcon">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <path
                d="M0 0L22 0 22 22 0 22z"
                transform="translate(-966 -396) translate(952 26) translate(14 370)"
              />
              <path
                fill="var(--dropdownIconColor)"
                fillRule="nonzero"
                d="M4.583 20.167c-.506 0-.916-.41-.916-.917V2.75c0-.506.41-.917.916-.917h12.834c.506 0 .916.41.916.917V5.5H16.5V3.667h-11v14.666h11V16.5h1.833v2.75c0 .506-.41.917-.916.917H4.583zm11.917-5.5v-2.75h-6.417v-1.834H16.5v-2.75L21.083 11 16.5 14.667z"
                transform="translate(-966 -396) translate(952 26) translate(14 370)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export const PortfolioMarginIcon = ({ className }) => {
  return (
    (<svg
      className={className}
      width="20"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-palette="PortfolioMarginIcon">
      <path
        d="M4.25 3.75V1.5C4.25 1.30109 4.32902 1.11032 4.46967 0.96967C4.61032 0.829018 4.80109 0.75 5 0.75H11C11.1989 0.75 11.3897 0.829018 11.5303 0.96967C11.671 1.11032 11.75 1.30109 11.75 1.5V3.75H14.75C14.9489 3.75 15.1397 3.82902 15.2803 3.96967C15.421 4.11032 15.5 4.30109 15.5 4.5V15C15.5 15.1989 15.421 15.3897 15.2803 15.5303C15.1397 15.671 14.9489 15.75 14.75 15.75H1.25C1.05109 15.75 0.860322 15.671 0.71967 15.5303C0.579018 15.3897 0.5 15.1989 0.5 15V4.5C0.5 4.30109 0.579018 4.11032 0.71967 3.96967C0.860322 3.82902 1.05109 3.75 1.25 3.75H4.25ZM2 12V14.25H14V12H2ZM2 10.5H14V5.25H2V10.5ZM5.75 2.25V3.75H10.25V2.25H5.75ZM7.25 8.25H8.75V9.75H7.25V8.25Z"
        fill="var(--dropdownIconColor)"
      />
    </svg>)
  );
};
